import React, { createContext, useContext, useState } from 'react';

interface SelectedItemsContextType {
  selectedItemKeys: Set<string>;
  setSelectedItemKeys: (keys: Set<string>) => void;
  clearSelectedItems: () => void;
}

const SelectedItemsContext = createContext<SelectedItemsContextType | undefined>(undefined);

export function SelectedItemsProvider({ children }: { children: React.ReactNode }) {
  const [selectedItemKeys, setSelectedItemKeys] = useState<Set<string>>(new Set());

  const clearSelectedItems = () => setSelectedItemKeys(new Set());

  return (
    <SelectedItemsContext.Provider value={{ selectedItemKeys, setSelectedItemKeys, clearSelectedItems }}>
      {children}
    </SelectedItemsContext.Provider>
  );
}

export function useSelectedItems() {
  const context = useContext(SelectedItemsContext);
  if (context === undefined) {
    throw new Error('useSelectedItems must be used within a SelectedItemsProvider');
  }
  return context;
}
